import React, { createContext, useContext } from 'react';

interface DragContextType {
  listeners?: any;
}

const DragContext = createContext<DragContextType>({});

export const DragProvider: React.FC<{ listeners?: any; children: React.ReactNode }> = ({ 
  listeners, 
  children 
}) => {
  return (
    <DragContext.Provider value={{ listeners }}>
      {children}
    </DragContext.Provider>
  );
};

export const useDragContext = () => {
  return useContext(DragContext);
};

export default DragContext;